var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sessions-store',{on:{"success":_vm.onSuccess},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var sid = ref.sid;
    var error = ref.error;
    var is_loading = ref.is_loading;
    var has_loaded = ref.has_loaded;
    var store = ref.store;
return [_c('sessions-create-form',{attrs:{"sid":sid,"is-saving":is_loading || has_loaded},on:{"submit":store},scopedSlots:_vm._u([{key:"modals",fn:function(){return [(error && _vm.$error.is(error, { exclude: [400, 422] }))?_c('error-modal',{attrs:{"error":error}}):_vm._e()]},proxy:true}],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }